<a
  [routerLink]="routerLink"
  routerLinkActive="active"
  pButton
  class="p-button-rounded p-button-toolbar p-button-text"
  *ngIf="access"
  [icon]="icon"
  [pTooltip]="'<strong>' + label + '</strong> ' + tooltip"
  [label]="labelVisibility ? label : ''"
  [escape]="false"
  (click)="navigateBack()"
  tooltipPosition="right"></a>
